export { DeleteModal } from './delete-modal';
